export const encriptaDatos = (dataHash: string, longitude: number) => {
  var bcrypt = require("bcryptjs");
  return bcrypt.hashSync(dataHash, longitude);
};
